import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { CountryManagementService } from 'src/app/core/services/country-management.service';
import { ToastrService } from 'ngx-toastr';
import { PermissionService } from 'src/app/core/services/permision.service';
import { ProductV2Service } from 'src/app/core/services/product-v2.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadGalleryComponent } from 'src/app/shared/ui/upload-gallery/upload-gallery.component';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// pages: country
@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})
export class AlertsComponent implements OnInit {

  sideForm: FormGroup;
  hasChanges = false;
  @Input() country;
  @Input() category;
  @Input() page;
  @Input() product;
  isSubmitted = false;

  isUpdating = false;
  deletedsideinfo = [];
  publishPage: string;
  isSuggestion: boolean;
  source = [];
  public Editor = ClassicEditor;
  public editorConfig = {
    toolbar: {
      items: ["bold", "italic"],
    },
  };

  constructor(private fb: FormBuilder, private countryApi: CountryManagementService,
    private toastr: ToastrService, public permission: PermissionService,
    private apiv2: ProductV2Service, private modalService: NgbModal) { }

  ngOnInit(): void {

    this.resetForm();
    this.getSideInfos();
    this.getSource();
    switch (this.page) {
      case 'country': this.publishPage = 'SideInfoCountry'; break;
      default: break;
    }

  }

  resetForm() {
    this.sideForm = this.fb.group({
      sideinfo: this.fb.array([])
    });
  }

  onSubmit(form) {
    if (form.valid) {
      this.isUpdating = true;
      this.deletedsideinfo.forEach(ae => {
        ae.is_updated = false;
        form.value.sideinfo.push(ae);
      })
      if (this.page == 'country') {
        form.value.sideinfo.forEach(ae => {
          ae.country = this.country;
        });
        this.countryApi.setSideInfoAlert(form.value.sideinfo).subscribe(
          () => {
            this.toastr.success("Content Updated Successfully!");
            this.getSideInfos();
            this.hasChanges = false;
            this.isUpdating = false;
          },
          () => {
            this.isUpdating = false;
          })
      }
    } else {
      this.isSubmitted = true;
      this.toastr.warning("Fill all fields and Save!");
    }
  }

  sideinfo(): FormArray {
    return this.sideForm.get("sideinfo") as FormArray
  }

  newsideinfo(): FormGroup {
    return this.fb.group({
      text: ['-'],
      source: ['', [Validators.required]],
      is_enabled: [false],
      country: [this.country],
      icon: [''],
      is_updated: [false],
    })
  }


  addsideinfo() {
    this.sideinfo().push(this.newsideinfo());
  }

  removesideinfo(i: number) {
    this.isSubmitted = false;
    this.sideForm.value.sideinfo[i].is_deleted = true;
    if (this.sideForm.value.sideinfo[i].hasOwnProperty("id")) this.deletedsideinfo.push(this.sideForm.value.sideinfo[i]);
    this.sideinfo().removeAt(i);
  }

  getSideInfos() {
    if (this.page == 'country') {
      this.getCountryData();
    }
  }

  getCountryData() {
    this.countryApi.getSideInfoAlert(this.country).subscribe(
      (result: any) => {
        this.setData(result);
      })
  }

  dataChanged(i) {
    this.sideForm.value.sideinfo[i].is_updated = true;
  }

  setData(result) {
    this.sideForm = this.fb.group({
      sideinfo: new FormArray([]),
    });
    result.forEach(ao => {
      (this.sideForm.get('sideinfo') as FormArray).push(
        this.fb.group({
          id: [this.isSuggestion ? null : ao.id],
          source: [ao.source, [Validators.required]],
          is_enabled: [ao.is_enabled || false],
          country: [this.country],
          icon: [ao.icon || ''],
          is_updated: [this.isSuggestion ? true : false],
          text: [ao.text, [Validators.required]]
        })
      );
    });
  }

  openUploadModal(i) {
    const modalRef = this.modalService.open(UploadGalleryComponent, {
      size: "xl",
      scrollable: true,
      windowClass: "modal-big-lg",
      keyboard: false,
      backdrop: "static",
    });
    modalRef.componentInstance.uploadDetails = {};
    modalRef.result.then((result) => {
      if (result.status) {
        this.sideinfo().at(i).get('icon').setValue(result.image);
        this.dataChanged(i);
      }
    });
  }

  checkPermission(type) {
    return this.permission.hasPermission(type);
  }

  getSource() {
    this.apiv2.getWhitelabelSources().subscribe((response: any) => {
      this.source = response;
    });
  }
}
